module.exports = __webpack_public_path__ + "static/img/pajiu.7d77742.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx/pajiu.png
// module id = OsBc
// module chunks = 0